import { TaskSummary } from "@common/types/task";

export type TaskSummariesDiffValue = string[] | TaskSummary[] | undefined;

export function toTaskSummaries(value: TaskSummariesDiffValue): TaskSummary[] {
    if (!value?.length) {
        return [];
    }
    const first = value[0];
    if (typeof first === "string") {
        return (value as string[]).map((id) => ({ id, title: id }));
    }
    return value as TaskSummary[];
}
